import type { MouseEvent } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { BRAND, type BrandLogoProps } from '../constants/brand'
import { cx } from '../helpers/format'
import '../styles/brand-logo.scss'

export function BrandLogo({
  to = '/',
  tone = 'on-light',
  onClick,
}: BrandLogoProps) {
  const { pathname } = useLocation()

  function onLogoClick(event: MouseEvent<HTMLAnchorElement>) {
    onClick?.()
    if (pathname === to) {
      event.preventDefault()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  return (
    <Link
      to={to}
      className={cx('brand-logo', `brand-logo--${tone}`)}
      aria-label={BRAND.homeAria}
      onClick={onLogoClick}
    >
      <img
        src={BRAND.logoSrc}
        alt={BRAND.logoAlt}
        className="brand-logo__image"
        width={BRAND.logoWidth}
        height={BRAND.logoHeight}
      />
    </Link>
  )
}
